import { Maybe } from '../graphql/generated/graphql'

export const formatCurrency = (amount: Maybe<number>, currency = 'USD'): string =>
    new Intl.NumberFormat('US-en', {
        style: 'currency',
        currency,
    }).format(amount ?? 0)

export const formatNumber = (amount: Maybe<number>): string =>
    new Intl.NumberFormat().format(amount ?? 0)

export const formatTokenAmount = (amount: Maybe<number>): string =>
    new Intl.NumberFormat('US-en', {
        maximumFractionDigits: 6,
    }).format(amount ?? 0)

export const formatPhoneNumber = (phoneNumberString: string) => {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
        var intlCode = match[1] ? '+1 ' : ''
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }
    return null
}
